import * as React from 'react'
import { MdConfirm, MdButton, MdErrors, MdVaultItemSelect } from '../widgets'
import { translate } from 'react-translate'
import { certifyEwarrant, requestEwarrant, cancelEwarrant, segregateVaultItemAgainstEwarrant } from '../../api/ewarrants'

class EvwSidePanel extends React.Component<EvwSidePanelProps, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      selectedVaultItemId: null,
      modalOpen: false,
      modalConfirmCallback: null,
      modalCancelCallback: null,
      modalContent: null,
      errors: []
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.cancelEwarrant = this.cancelEwarrant.bind(this)
    this.requestEwarrant = this.requestEwarrant.bind(this)
    this.certifyEwarrant = this.certifyEwarrant.bind(this)
    this.segregateVaultItemAgainstEwarrant = this.segregateVaultItemAgainstEwarrant.bind(this)
  }
  public requestEwarrant () {
    const accountId = this.props.selectedRow.accountId
    const contractId = this.props.selectedRow.contractId
    const quantity = 1
    requestEwarrant(accountId, contractId, quantity).then(() => {
      this.props.updateDataset()
      this.closeModal()
      this.toast('createConfirmSuccess')
    }, (err) => {
      this.closeModal()
      this.setState({
        errors: [...this.state.errors, ...err.response.data.errors]
      })
    })
  }

  private toast(id) {
    document.getElementById(id).style.display = 'flex'
    setTimeout(() => {
      if (document.getElementById(id)) { document.getElementById(id).style.display = 'none' }
    }, 3500)
  }

  public certifyEwarrant () {
    certifyEwarrant(this.props.selectedRow.id).then(() => {
      this.props.updateDataset()
      this.props.clearSelectedRow()
    }, (err) => {
      this.closeModal()
      this.setState({
        errors: [...this.state.errors, ...err.response.data.errors]
      })
    })
  }
  public cancelEwarrant () {
    cancelEwarrant(this.props.selectedRow.id).then(() => {
      this.props.updateDataset()
      this.props.clearSelectedRow()
    }, (err) => {
      this.closeModal()
      this.setState({
        errors: [...this.state.errors, ...err.response.data.errors]
      })
    })
  }
  public segregateVaultItemAgainstEwarrant () {
    segregateVaultItemAgainstEwarrant(this.props.selectedRow.id, this.state.selectedVaultItemId).then(() => {
      this.props.updateDataset()
      this.props.clearSelectedRow()
      this.setState({
        selectedVaultItemId: null
      })
    }, (err) => {
      this.closeModal()
      this.setState({
        errors: [...this.state.errors, ...err.response.data.errors]
      })
    })
  }

  public handleVaultItemChange (item) {
    this.setState({
      selectedVaultItemId: item ? item.id : null
    })
  }

  public closeModal() {
    this.setState({
      modalOpen: false,
      modalConfirmCallback: null,
      modalCancelCallback: null,
      modalContent: null,
      errors: []
    })
  }

  public openModal(confirmCallback: Function, cancelCallback: Function, content?: any) {
    this.setState({
      modalOpen: true,
      modalConfirmCallback: confirmCallback,
      modalCancelCallback: cancelCallback,
      modalContent: content || null
    })
  }

  public componentWillReceiveProps(nextProps) {
    this.closeModal()
  }

  private shouldShowCertifyButton() {
    return this.props.selectedRow.status === EwarrantStatus.segregated &&
           window['md3'].account.active.categoryId === AccountCategories.centralClearingParty &&
           (this.props.selectedRow.serialNumber !== '' && this.props.selectedRow.hallmark !== '')
  }

  public render() {
    const t = this.props.t
    return (
      <div>
        <MdConfirm
          open={this.state.modalOpen}
          confirmCallback={this.state.modalConfirmCallback}
          cancelCallback={this.state.modalCancelCallback}>
          {this.state.modalContent}
        </MdConfirm>
        <div style={{color: 'white'}} className='evwSidePanel'>
          {
            (this.props.selectedRow !== null) ? (
              <div>
                <h3 className='account-title'>{this.props.selectedRow.accountName}</h3>

                <ul className='summary-list'>
                  <li>
                    <strong>{t('HIN')}</strong>
                    <span>{this.props.selectedRow.hin}</span>
                  </li>
                  <li>
                    <strong>{t('HUB')}</strong>
                    <span>{this.props.selectedRow.hubName}</span>
                  </li>
                  <li>
                    <strong>{t('PRODUCT')}</strong>
                    <span>{this.props.selectedRow.productName}</span>
                  </li>
                  {this.props.selectedRow.serialNumber &&
                  <li>
                    <strong>{t('SERIAL_NUMBER')}</strong>
                    <span>{this.props.selectedRow.serialNumber}</span>
                  </li>
                  }
                  {this.props.selectedRow.hallmark &&
                  <li>
                    <strong>{t('HALLMARK')}</strong>
                    <span>{this.props.selectedRow.hallmark}</span>
                  </li>
                  }
                  {this.props.selectedRow.warrantNumber &&
                  <li>
                    <strong>{t('WARRANT_NUMBER')}</strong>
                    <span>{this.props.selectedRow.warrantNumber}</span>
                  </li>
                  }
                  {this.props.activeStatus === 'Available' &&
                  <li>
                    <strong>{t('AVAILABLE')}</strong>
                    <span>{this.props.selectedRow.availableForEvw}</span>
                  </li>
                  }
                  {this.props.activeStatus === 'Available' &&
                  <li>
                    <strong>{t('IN_PROGRESS')}</strong>
                    <span>{this.props.selectedRow.evwInProgress}</span>
                  </li>
                  }
                </ul>

                {this.props.activeStatus === 'Created' &&
                window['md3'].account.active.categoryId === AccountCategories.centralClearingParty &&
                  <div>
                    <h4>Select Item for EVW</h4>
                    {this.props.availableVaultItems.length > 0 &&
                      <MdVaultItemSelect
                        vaultItemList={this.props.availableVaultItems}
                        onItemChange={(i) => this.handleVaultItemChange(i)}
                      />
                    }

                    {
                      this.props.availableVaultItems.length === 0 &&
                      (this.props.selectedRow.status === EwarrantStatus.segregated || this.props.selectedRow.status === EwarrantStatus.created) &&
                      <MdErrors errors={[{detail: 'No other items are available for EVW.'}]} />
                    }
                  </div>
                }

                <footer>
                  {this.props.activeStatus === 'Available' &&
                    <span style={{width: '100%'}}>
                      { (this.props.selectedRow.availableForEvw > 0 && window['md3'].account.active.categoryId !== AccountCategories.centralClearingParty) &&
                        <div>
                          <MdButton
                            text={'Create Ewarrant'}
                            clickHandler={() => this.openModal(
                              this.requestEwarrant,
                              this.closeModal,
                              (<p>{t('CREATE_EVW_MODAL_TEXT')}</p>))}
                          />
                        </div>
                      }
                      <div>
                        <div id='createConfirmSuccess' className='toast success'><span>{t('EWARRANT_CREATED')}</span></div>
                      </div>
                      <div>
                      {
                        this.state.errors.length > 0 ?
                          <MdErrors errors={this.state.errors} /> : null
                      }
                    </div>
                    </span>
                  }

                  {this.props.activeStatus === 'Created' &&
                    (
                      <span style={{width: '100%'}}>
                        {this.state.selectedVaultItemId !== null &&
                        window['md3'].account.active.categoryId === AccountCategories.centralClearingParty &&
                          <div>
                            <MdButton
                              text={'Change Vault Item'}
                              clickHandler={() => this.openModal(
                                this.segregateVaultItemAgainstEwarrant,
                                this.closeModal,
                                (<p>{t('CHANGE_VAULT_ITEM_EVW_MODAL_TEXT')}</p>)
                              )}
                            />
                          </div>
                        }
                        <div>
                          {
                            this.shouldShowCertifyButton() &&
                            <MdButton
                            text={'Certify Ewarrant'}
                            clickHandler={() => this.openModal(
                              this.certifyEwarrant,
                              this.closeModal,
                              (<p>{t('CERTIFY_EVW_MODAL_TEXT')}</p>)
                              )}
                            />
                          }
                        </div>
                        <div>
                          <MdButton
                          text={'Cancel Ewarrant'}
                          clickHandler={() => this.openModal(
                            this.cancelEwarrant,
                            this.closeModal,
                            (<p>{t('CANCEL_REQUESTED_MODAL_TEXT')}</p>))} />
                        </div>
                        <div>
                          {
                            this.state.errors.length > 0 ?
                              <MdErrors errors={this.state.errors} /> : null
                          }
                        </div>
                      </span>
                    )
                  }

                  {this.props.activeStatus === 'Certified' &&
                    <span style={{width: '100%'}}>
                      <div>
                        <MdButton
                          text={'View PDF'}
                          clickHandler={() => window.open('/md3api/reports/ewarrantCertificate-' + this.props.selectedRow.id + '-en.pdf')}
                        />
                      </div>
                      <div>
                        <MdButton
                          text={'Cancel Ewarrant'}
                          clickHandler={() => this.openModal(
                            this.cancelEwarrant,
                            this.closeModal,
                            (<p>{t('CANCEL_CERTIFIED_MODAL_TEXT')}</p>))} />
                      </div>
                      <div>
                        {
                          this.state.errors.length > 0 ?
                            <MdErrors errors={this.state.errors} /> : null
                        }
                      </div>
                    </span>
                  }
                  <MdButton
                  text={'Close Panel'}
                  style={{
                    'box-shadow': 'inset 0 0 0 2px rgba(100, 100, 100, 0.6)',
                    'background-color': 'transparent'
                  }}
                  clickHandler={() => this.props.closePanel()} />
                </footer>

              </div>
            ) : (null)
          }
        </div>
      </div>
    )
  }
}

export default translate('EvwSidePanel')(EvwSidePanel)



// WEBPACK FOOTER //
// ./react/components/presentations/EvwSidePanel.tsx